import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/horace/Projects/JiuYou/uono_web/src/layouts/default.vue").then(m => m.default || m))
}